import { SxStyleProp } from 'theme-ui';

export const Container: SxStyleProp = {
  textAlign: 'center',
  padding: ['0px 20px', '0px'],
};

export const Title: SxStyleProp = {
  variant: 'text.h4',
};

export const Flex: SxStyleProp = {
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  marginTop: ['15px', '76px'],
  marginBottom: ['70px', '160px'],
  maxWidth: [null, '1373px'],
  marginX: 'auto',
};

export const FlexItem: SxStyleProp = {
  '@media screen and (min-width: 768px)': {
    flexBasis: '30%',
    width: '30%',
  },
  flexBasis: ['50%', '30%', null, '25%', null, '17%'],
  width: ['50%', '30%', null, '25%', null, '17%'],
  marginBottom: ['5px'],
};

export const FlexImage: SxStyleProp = {
  marginX: 'auto',
  img: {
    objectFit: 'contain !important',
    filter: 'brightness(0)',
  },
};
